import React from 'react';

const MentorsAllPage = () => {
  return <div>MentorsAllPage</div>;
};

export default MentorsAllPage;
